// NEW GEN Blackline — global scripts
(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Seamless announcement ticker: clone the message group until it overfills
  // the bar, then shift by exactly one group width per loop.
  document.querySelectorAll('.announce--scroll .announce__inner').forEach(function (inner) {
    var group = inner.querySelector('.announce__group');
    if (!group) return;
    var groupWidth = group.getBoundingClientRect().width + parseFloat(getComputedStyle(group).marginRight || 0);
    if (!groupWidth) return;
    var needed = Math.ceil((inner.parentElement.offsetWidth * 2 + groupWidth) / groupWidth);
    while (inner.children.length < needed) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      inner.appendChild(clone);
    }
    inner.style.setProperty('--announce-shift', groupWidth + 'px');
  });

  // Spin-on-scroll for hero feature images
  var spinners = document.querySelectorAll('[data-spin] img');
  if (spinners.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var deg = (window.scrollY * 0.08).toFixed(2);
        spinners.forEach(function (img) {
          img.style.transform = 'rotate(' + deg + 'deg)';
        });
        ticking = false;
      });
    }, { passive: true });
  }

  // Hide the floating hCaptcha/reCAPTCHA badge — attribution is shown inline
  // next to the protected forms instead. Only small fixed-position widgets are
  // hidden; full-size challenge popups stay visible and functional.
  function hideCaptchaBadge() {
    document.querySelectorAll('iframe[src*="hcaptcha"], iframe[src*="recaptcha"]').forEach(function (frame) {
      var el = frame;
      while (el && el !== document.body) {
        if (getComputedStyle(el).position === 'fixed') {
          var r = el.getBoundingClientRect();
          if (r.height > 0 && r.height < 160 && r.width < 420) {
            el.style.visibility = 'hidden';
            el.style.pointerEvents = 'none';
          }
          return;
        }
        el = el.parentElement;
      }
    });
  }
  hideCaptchaBadge();
  if (window.MutationObserver) {
    new MutationObserver(hideCaptchaBadge).observe(document.body, { childList: true, subtree: true });
  }

  // Keep cart count fresh after add-to-cart form submissions on the same page
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  });
})();
